/**
 * Overrides Bazaarvoice inline star dimensions (17px !important)
 * so our theme CSS (12px) can apply. Inline !important cannot be
 * overridden by stylesheets; this script runs after BV loads.
 */
(function() {
  const SIZE = '12px';
  const GAP_AFTER_RATING = '4px';
  /** Matches e.g. "4.6 out of 5 stars. 1663 reviews" */
  const ARIA_AVERAGE_RATING_RE = /^([\d.]+)\s+out of\s+\d/i;

  function setSvgSize(svg) {
    svg.style.setProperty('width', SIZE, 'important');
    svg.style.setProperty('height', SIZE, 'important');
  }

  function injectAverageRatingFromAriaLabel(main) {
    if (!main || main.querySelector('.bv-average-rating')) {
      return;
    }
    var label = main.getAttribute('aria-label');
    if (!label) {
      return;
    }
    var match = label.match(ARIA_AVERAGE_RATING_RE);
    if (!match) {
      return;
    }
    var div = document.createElement('div');
    div.className = 'bv-average-rating';
    div.setAttribute('aria-hidden', 'true');
    div.textContent = match[1];
    main.insertBefore(div, main.firstChild);
  }

  function processContainer(container) {
    var mains = container.querySelectorAll('[data-bv-show="inline_rating"] .bv_main_container');
    mains.forEach(injectAverageRatingFromAriaLabel);

    if (container === document.querySelector('.product__block--product-header')) return;

    const svgs = container.querySelectorAll('[data-bv-show="inline_rating"] .bv_main_container svg');
    svgs.forEach(setSvgSize);
  }

  const CONTAINER_SELECTORS = [
    '.product__block--product-header',
    '.product-item__price-wrap[data-position="below_title"]',
    '.custom-css__routine-steps-card-product-wrapper',
    '.custom-css__routine-steps-card-content',
    '.custom-css__before-and-after-product-meta'
  ];

  function observeAndProcess() {
    const containers = document.querySelectorAll(CONTAINER_SELECTORS.join(', '));
    containers.forEach(function(container) {
      processContainer(container);
      const observer = new MutationObserver(function() {
        processContainer(container);
      });
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  /** True on product URLs like /products/handle or /en/products/handle */
  function isProductDetailPage() {
    return /\/products\/[^/]+/.test(window.location.pathname);
  }

  /** BV may put `data-bv-show` on a parent or on `a.bv_main_container` itself (descendant selector misses the latter). */
  var INLINE_RATING_MAIN_SEL =
    '[data-bv-show="inline_rating"].bv_main_container, [data-bv-show="inline_rating"] .bv_main_container';

  function initInlineRatingClickScrollToReviews() {
    if (!isProductDetailPage()) {
      return;
    }
    document.addEventListener(
      'click',
      function(e) {
        if (e.defaultPrevented) return;
        if (e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        var main = e.target.closest(INLINE_RATING_MAIN_SEL);
        if (!main) return;

        var reviewsSection = document.querySelector('[data-pdp_section="reviews"]');
        if (!reviewsSection) return;

        e.preventDefault();
        e.stopPropagation();
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      },
      true
    );
  }

  function boot() {
    observeAndProcess();
    initInlineRatingClickScrollToReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', observeAndProcess);
})();
